import type { FC } from 'react';

interface CommentItem {
  id: number;
  name: string;
  avatarBg: string;
  initial: string;
  date: string;
  comic: string;
  rating: number;
  content: string;
}

const comments: CommentItem[] = [
  {
    id: 1,
    name: '星辰大海',
    avatarBg: 'bg-primary-500',
    initial: '星',
    date: '2026-07-27',
    comic: '《仙王的日常生活》',
    rating: 5,
    content: '香香漫画真的太赞了！下拉式阅读体验丝滑流畅，追更不用翻页太方便了。画质清晰资源全，是我用过最好的香香漫画免费看平台！',
  },
  {
    id: 2,
    name: '漫画迷小陈',
    avatarBg: 'bg-accent-500',
    initial: '陈',
    date: '2026-07-26',
    comic: '《斗破苍穹》',
    rating: 5,
    content: '在这里找到了好多好看的漫画免费全集，更新速度贼快！香香漫画大全免费看，省了好多钱，强烈推荐给所有漫画爱好者！',
  },
  {
    id: 3,
    name: '追更小能手',
    avatarBg: 'bg-secondary-500',
    initial: '追',
    date: '2026-07-25',
    comic: '《一人之下》',
    rating: 4,
    content: '香香漫画免费下拉真的太方便了，上班摸鱼的时候偷偷看几话，下拉就能一直读。资源丰富分类清晰，找漫画特别快。',
  },
  {
    id: 4,
    name: '日漫爱好者',
    avatarBg: 'bg-primary-400',
    initial: '漫',
    date: '2026-07-24',
    comic: '《咒术回战》',
    rating: 5,
    content: '从学生时代就开始看漫画了，用了很多平台，香香漫画是体验最好的。香香漫画全集免费，画质高清，加载快，真心推荐！',
  },
];

const CommentCard: FC<{ item: CommentItem }> = ({ item }) => (
  <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
    <div className="flex items-start gap-3 mb-3">
      <div className={`w-10 h-10 rounded-full ${item.avatarBg} flex items-center justify-center text-background-50 font-bold text-sm shrink-0`}>
        {item.initial}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="font-semibold text-foreground-900 text-sm whitespace-nowrap">{item.name}</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
        </div>
        <div className="flex items-center gap-1 mt-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <i
              key={i}
              className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
            ></i>
          ))}
        </div>
      </div>
    </div>
    <p className="text-sm text-foreground-700 leading-relaxed mb-2">{item.content}</p>
    <span className="inline-block text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">{item.comic}</span>
  </div>
);

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">读者热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">看看漫画迷们怎么说，香香漫画用过的都说好</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((item) => (
            <CommentCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}